// 获取文章详情页url
export const detailUrl = {

    zzgg: (id) => "detail?nav=01&id=" + id,

    zzgp: (id) => "detail?nav=02&id=" + id,

    jggs: (id) => "detail?nav=03&id=" + id,

    sygp: (id) => "detail?nav=04&id=" + id,

    qwss: (id) => "detail?nav=05&id=" + id,

    zzzs: (id) => "detail?nav=06&id=" + id,

}